import { collection } from 'firebase/firestore';
import { useContext, useMemo } from 'react';
import { FirebaseAppContext, FirebaseAuthContext } from 'libs.firebase_react';
export function useJobsCollection() {
    const { db } = useContext(FirebaseAppContext);
    const { userClaims, loading: loadingAuth, error: errorAuth } = useContext(FirebaseAuthContext);
    const entityId = userClaims === null || userClaims === void 0 ? void 0 : userClaims.entityId;
    const coll = useMemo(() => {
        if (loadingAuth || errorAuth || !db || !entityId) {
            return null;
        }
        return collection(db, `entities/${entityId}/jobs`);
    }, [loadingAuth, errorAuth, db, entityId]);
    return { user: userClaims === null || userClaims === void 0 ? void 0 : userClaims.user_id, collection: coll, loading: loadingAuth, error: errorAuth };
}
//# sourceMappingURL=use_jobs_collection.hook.js.map